import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type { RESTGetAPIVoiceRegionsResult, APIVoiceState } from "discord-api-types/v10";





class VoiceMethods {








	public constructor(public requestHandler: RH) {}










	public async getVoiceRegions(): Promise<RESTGetAPIVoiceRegionsResult> {
		return this.requestHandler.request(Endpoints.VOICE_REGIONS, {}, "get", "json");
	}







	public async getCurrentUserVoiceState(guildId: string): Promise<APIVoiceState> {
		return this.requestHandler.request(Endpoints.USER_GUILD_VOICE_STATE(guildId, "@me"), {}, "get", "json")
	}








	public async getUserVoiceState(guildId: string, userId: string): Promise<APIVoiceState> {
		return this.requestHandler.request(Endpoints.USER_GUILD_VOICE_STATE(guildId, userId), {}, "get", "json")
	}
}

export = VoiceMethods;
